(function () {
  angular.module('MktzapApp.Factories')
    .factory('HandleAttendanceService', HandleAttendanceService);

  HandleAttendanceService.$inject = ['$resource'];

  function HandleAttendanceService ($resource) {
    return $resource(apiUrl + '/channels-plugin/handle-attendance/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: false }
    });
  }
})();
